import React, { Component } from "react"
import { connect } from "react-redux"
import {
  refreshUserConfig,
  search,
  searchNextPage,
  debtAdvancedSearch,
  submitToCitius,
} from "../../actions"
import DebtList from "../../components/DebtList"
import { handlePickedBoxes } from "../../utils"
import * as strings from "../../strings"
import Dropdown from "react-toolbox/lib/dropdown"
import FontIcon from "react-toolbox/lib/font_icon"
import Input from "react-toolbox/lib/input"
import { Button } from "react-toolbox/lib/button"
import SearchFilter from "../../components/SearchFilter"
import styles from "./style.css"
import _ from "lodash"

const CONFIG_ITEM_MAP = {
  // TODO: Check if these two are correct
  id: "idDebt",
  processId: "plid",

  name: "name",
  nif: "nif",
  procedurePhase: "debtPhase",

  injunctionId: "injunctionNumber",

  debtValue: "debtValue",
  clientName: "clientName",

  // "preLitigationSubType",
  // "preLitigationType",

  // "litigationSubType",
  // "litigationType",

  // "executionNumber",

  court: "executionService",
}

// TODO: change when we implement pagination
const ITEMS_PER_PAGE = 10
const FIRST_PAGE = 1
const INITIAL_PAGINATION = {
  limit: ITEMS_PER_PAGE,
  offset: 0,
}

class AdvancedSearch extends Component {
  props: {
    refreshUserConfig: () => {},
    search: ( type: string, params: any, pagination?: any ) => any,
    searchNextPage: ( type: string ) => any,
    suggestions: any,
    auth: any,
    user: {
      config: []
    },
  }

  state = {
    filterExpanded: false,
    results: undefined,
    filters: {},
    pagination: INITIAL_PAGINATION,
    pickedDebts: [],
    itemsPerPage: ITEMS_PER_PAGE,
    activePage: FIRST_PAGE,
    totalItems: undefined,
    showCustomPagination: false,
    customNumberOfItems: ITEMS_PER_PAGE,
    customizedNumber: undefined,
    differentPagination: [
      { value: 10, label: "10" },
      { value: 50, label: "50" },
      { value: 100, label: "100" },
      { value: "personalizar", label: strings.generalStrings.customize },
    ],
  }

  pickAllProcesses = async () => {
    const { token } = this.props.auth
    const { filters } = this.state

    const response = await debtAdvancedSearch(
      token,
      _.pickBy( filters, _.identity ),
      {
        limit: Number.MAX_SAFE_INTEGER,
        offset: 0,
      },
      { ids: true }
    )

    if ( response.message !== "OK" ) {
      return null
    }

    return this.setState( {
      pickedDebts: response.result.data,
    } )
  }

  pickedBoxesHandler = ( element ) => () => {
    return this.setState( {
      pickedDebts: handlePickedBoxes( element, this.state.pickedDebts, this.state.results ),
    } )
  }

  handleDifferentPagination = ( itemsPerPage ) => {
    if ( _.isEqual( itemsPerPage, "personalizar" ) ) {
      this.setState( {
        showCustomPagination: true,
        customNumberOfItems: itemsPerPage,
      } )
    } else {
      const newPagination = {
        limit: itemsPerPage,
        offset: 0,
      }
      this.fetchResults( newPagination )
      this.setState( {
        showCustomPagination: false,
        customNumberOfItems: itemsPerPage,
        customizedNumber: undefined,
      } )
    }
  }

  handlePageChange = ( pageNumber ) => {
    const { pagination } = this.state
    const newPagination = {
      limit: pagination.limit,
      offset: ( pagination.limit * pageNumber ) - pagination.limit,
    }
    this.fetchResults( newPagination )
  }

  handleCustomPagination = () => {
    const newPagination = {
      limit: _.isEqual( this.state.customizedNumber, "" ) ? this.state.pagination.limit : this.state.customizedNumber,
      offset: 0,
    }
    this.fetchResults( newPagination )
  }

  fetchResults = async ( pagination ) => {
    const { token } = this.props.auth
    const { filters } = this.state

    const response = await debtAdvancedSearch( token, filters, pagination )

    if ( response.message !== "OK" ) {
      return false
    }

    const { result } = response

    const activePage = this.getActivePage( pagination )

    await this.setState( {
      results: result,
      totalItems: result.count,
      pagination,
      activePage,
    } )

    return true
  }

  getActivePage = ( pagination ) => {
    const { offset, limit } = pagination
    return offset / limit + 1
  }


  componentWillMount = () => {
    this.fetchResults( this.state.pagination )
  }

  renderResults = () => {
    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column", marginTop: "20px" }}>
        <div className={styles.topButtonsContainer}>
          <Button label={strings.generalStrings.pickAllProcesses}
            onClick={this.pickAllProcesses} raised primary />
          <Dropdown
            auto
            label={strings.generalStrings.itemsPerPage}
            onChange={this.handleDifferentPagination}
            source={this.state.differentPagination}
            value={this.state.customNumberOfItems}
          />
          {this.state.showCustomPagination ?
            <div>
              <Input type="number" label={strings.generalStrings.numberOfItemsPerPage}
                name="name" value={this.state.customizedNumber}
                onChange={ ( customNumberOfItems ) => this.setState( {
                  customizedNumber: _.isEqual( customNumberOfItems, "" ) ? customNumberOfItems : parseFloat( customNumberOfItems ),
                } )}
                onBlur={this.handleCustomPagination} />
            </div> : <div/>}
        </div>
        <DebtList
          items={this.state.results || []}
          userConfig={this.props.user.config}
          configItemMap={CONFIG_ITEM_MAP}
          itemsPerPage={this.state.pagination.limit}
          activePage={this.state.activePage}
          totalItems={this.state.totalItems}
          handlePageChange={this.handlePageChange}
          onChange={this.pickedBoxesHandler}
          pickedDebts={this.state.pickedDebts}
          submitToCitius={ids => submitToCitius( this.props.auth.token, ids )}
          filters={this.state.filters}
        />
      </div>
    )
  }

  renderLoadingDialog = () => {
    return (
      <div className={styles.loadingWrapper}>
        <div className={styles.loader} />
      </div>
    )
  }

  renderError = () => {
    return (
      <div className={styles.errorWrapper}>
        <FontIcon value="error" className={styles.errorIcon} />
        <div className={styles.errorText}>
          Occoreu um erro!
        </div>
      </div>
    )
  }

  render () {
    if ( this.state.results === undefined ) {
      return this.renderLoadingDialog()
    }

    return (
      <div className={styles.root}>
        <SearchFilter
          value={this.state.filters}
          onChange={newFilters => this.setState( {
            filters: newFilters,
          } )}
          expanded={this.state.filterExpanded}
          onExpand={() => this.setState( {
            filterExpanded: !this.state.filterExpanded,
          } )}
          procedureSearch={ async ( filters ) => {
            await this.setState( {
              pickedDebts: [],
              filters,
              filterExpanded: false,
              results: undefined,
            } )
            return await this.fetchResults( INITIAL_PAGINATION )
              .then( isSucessfull => {
                if ( !isSucessfull ) {
                  throw new Error( "Search failed" )
                }
              } )
              .catch( () => this.setState( {
                results: null,
              } ) )
          }}
          suggestions={this.props.suggestions}
        />
        {
          ( this.state.results === null ) ? this.renderError() : this.renderResults()
        }
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    searchResults: store.search || [],
    suggestions: store.suggestions,
    user: store.user,
    auth: store.auth,
  }
}

export default connect(
  mapStateToProps,
  { refreshUserConfig, search, searchNextPage }
)( AdvancedSearch )



// WEBPACK FOOTER //
// ./src/views/AdvancedSearch/index.jsx